module.exports = __webpack_public_path__ + "static/media/10.66a44e2b.jpg";